import { render, staticRenderFns } from "./WhatDashboardModal.vue?vue&type=template&id=6f44b2c5&"
import script from "./WhatDashboardModal.vue?vue&type=script&lang=ts&"
export * from "./WhatDashboardModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports